import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormControl, AbstractControlOptions, AbstractControl, FormGroup } from '@angular/forms';
import { NospaceValidator } from 'src/app/core/validators/nospace-validator';
import { MustMatch } from 'src/app/core/validators/password-validator';
import { OutsideClickErrorStateMatcher } from 'src/app/core/validators/outclick-validators';
import { CommonHelperService } from 'src/app/core/utilities/common-helper/common-helper.service';
import { UserFacadeService } from 'src/app/facades/user/user-facade.service';
import { UserOnboarding } from 'src/app/core/models/user/user-onboarding.model';
import { AuthFacadeService } from 'src/app/facades/auth/auth-facade.service';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { ClientFacadeService } from 'src/app/facades/client/client-facade.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { LocationFacadesService } from 'src/app/facades/location/location-facades.service';
import { StylistFacadesService } from 'src/app/facades/stylist/stylist-facades.service';
import { map, startWith } from 'rxjs';

@Component({
  selector: 'app-free-onboard',
  templateUrl: './free-onboard.component.html',
  styleUrls: ['./free-onboard.component.scss']
})
export class FreeOnboardComponent implements OnInit {

  emailFormGroup: FormGroup;
  personalFormGroup: FormGroup;
  businessFormGroup: FormGroup;
  stylistFormGroup: FormGroup;
  styEmailFormGroup: FormGroup;
  showNewPassword!: boolean;
  showConfirmPassword!: boolean;
  darkMode: boolean = false;
  loadingUserDataByEmail: boolean = false;
  matcher = new OutsideClickErrorStateMatcher();
  formSubmissionInfo: { email: any; personal: any; business: any; };
  signupAuthInfo: { authId: any; signInMethod: any; };
  phoneInputComponent: NgxMatIntlTelInputComponent;
  filteredCountry: any;
  filteredState: any;
  country: string;
  styOptionVal: boolean;
  clientId: any;
  locId: any;
  @ViewChild('phoneInput', { static: false }) set phoneInput(
    content: NgxMatIntlTelInputComponent) {
    if (content) {
      this.phoneInputComponent = content;
    }
  }
  selectedCountry: any = { iso2: 'us', dialCode: '+1' };
  constructor(
    private formBuilder: FormBuilder,
    private commonHelper: CommonHelperService,
    private userFacadeService: UserFacadeService,
    private authServiceFacade: AuthFacadeService,
    private clientFacade: ClientFacadeService,
    private locationFacadeService: LocationFacadesService,
    private stylistFacadeService: StylistFacadesService
  ) {
    this.darkMode = this.commonHelper.isDarkEnabled();
    this.emailFormGroup = this.formBuilder.group({
      "emailCtrl": new FormControl('', [Validators.required, Validators.email, NospaceValidator.blockSpace]),
    });
    this.personalFormGroup = this.formBuilder.group({
      "firstName": new FormControl('', [Validators.required, NospaceValidator.blockSpace]),
      "lastName": new FormControl('', [Validators.required, NospaceValidator.blockSpace]),
      "mobNumber": new FormControl('', [Validators.required]),
      "password": new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]),
      "confirmPassword": new FormControl('', [Validators.required])
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
    this.businessFormGroup = this.formBuilder.group({
      "busiName": new FormControl('', Validators.required),
      "cliLocName": new FormControl('', [Validators.required]),
      "address1": new FormControl('', Validators.required),
      "address2": new FormControl('', Validators.required),
      "city": new FormControl('', Validators.required),
      "country": new FormControl('', Validators.required),
      "state": new FormControl('', Validators.required),
      "zipCode": new FormControl('', Validators.required),
      "timezone": new FormControl('', Validators.required),
    });
    this.stylistFormGroup = this.formBuilder.group({
      "locName": new FormControl('', [Validators.required]),
      "studioNumber": new FormControl('', [Validators.required]),
      "studioName": new FormControl('', [Validators.required]),
    })
    this.styEmailFormGroup = this.formBuilder.group({
      "styEmail": new FormControl('', [Validators.required, Validators.email, NospaceValidator.blockSpace]),
    })
  }
  
  isSubmitted: boolean = false;
  isProcessing: boolean = false;
  stopRegistration: boolean = false;
  hidePasswords: boolean = false;
  passwordMessage: string = "";
  countryList: any[] = [];
  stateList: any[] = [];
  onBoardingUserDetails: UserOnboarding;

  ngOnInit(): void {
    this.fetchCountryList();
  }
  get password(): AbstractControl {
    return this.personalFormGroup.get('password');
  }

  get confirmPassword(): AbstractControl {
    return this.personalFormGroup.get('confirmPassword');
  }
  get emailfval() {
    return this.emailFormGroup.controls;
  }

  get perfval() {
    return this.personalFormGroup.controls;
  }

  get styemailfval(){
    return this.styEmailFormGroup.controls;
  }

  get styfval() {
   return this.stylistFormGroup.controls;
  }

  get busifval() {
    return this.businessFormGroup.controls;
  }

  fetchUserDetails(event) {
    this.loadingUserDataByEmail = true;
    const email = this.emailFormGroup.get('emailCtrl').value;
    this.userFacadeService.GetUserByEmailOnBoarding(email).subscribe({
      next: (response: UserOnboarding) => {
        this.loadingUserDataByEmail = false;
        this.onBoardingUserDetails = response;

        if (response.userType == "Customer") {
          if(this.onBoardingUserDetails.isFirebaseRegistered == false){
            this.hidePasswords = true;
            //this.passwordMessage = "*Your email is registered with us as a customer. Please continue to add yourself to the business and use the same password or Google/Apple login after you have been approved by the business owner/administrator.";
            this.removePasswordValidations();
            this.stopRegistration = false;
          }else{
            this.hidePasswords = true;
            this.passwordMessage = "*Your email is registered with us as a customer. Please continue to add yourself to the business and use the same password or Google/Apple login after you have been approved by the business owner/administrator.";
            this.removePasswordValidations();
            this.stopRegistration = false;
          }
         }
        else if (response.userType == "ServiceProvider") {
          this.hidePasswords = true;
          this.removePasswordValidations();
          this.passwordMessage = "*You are already a registered user. Please contact support@visitmaker.com";
          this.stopRegistration = true;
        } else {
          this.hidePasswords = false;
          this.setPasswordValidations();
          this.stopRegistration = false;
          this.passwordMessage = "";
        }

      }, error: (error) => {
        // handle error.
      }
    })
  }

  submitOnboardingForm() {
    this.loadingUserDataByEmail = true;
    if (this.emailFormGroup.valid &&
      this.personalFormGroup.valid &&
      this.businessFormGroup.valid) {
      const formValue = {
        email: this.emailFormGroup.value,
        personal: this.personalFormGroup.value,
        business: this.businessFormGroup.value
      };
      this.formSubmissionInfo = formValue;
      const email = formValue.email.emailCtrl;
      const pass = formValue.personal.password;
      if (this.onBoardingUserDetails.userType == "Customer" || this.onBoardingUserDetails.userType == "") {
        if (this.onBoardingUserDetails.isFirebaseRegistered == false) {
          this.authServiceFacade.signUp(email, pass).then((response: any) => {
            const authInfo = {
              authId: response.uid,
              signInMethod: response.providerData[0].providerId
            }
            this.signupAuthInfo = authInfo;
            this.verifyEmail(authInfo);
          }).catch((error) => {
            // handle error here
            this.isProcessing = false;
            this.stopRegistration = true;
            this.errorSocialMessage(error);
          })
        } else {
          this.submitOnboardingDetails();
        }
      } else {
        this.submitOnboardingDetails();
      }

    }
  }

  submitOnboardingDetails() {
    this.loadingUserDataByEmail = true;
    try {
    const authId = (this.onBoardingUserDetails.userTypeId == 1) ? (this.onBoardingUserDetails.authId) : (this.signupAuthInfo.authId);
    const signInMethod = (this.onBoardingUserDetails.userTypeId == 1) ? (this.onBoardingUserDetails.signInMethod) : (this.signupAuthInfo.signInMethod);
    const dialCode = '+' + this.phoneInputComponent.selectedCountry.dialCode;
    const isoCode = this.phoneInputComponent.selectedCountry.iso2.toString().toUpperCase();
    const phoneNo = this.phoneInputComponent.phoneNumber;
    let data = {
      "id": 0,
      "logo": "",
      "businessName": this.formSubmissionInfo.business.busiName,
      "businessImage": "",
      "businessWebsite": "",
      "address1": this.formSubmissionInfo.business.address1,
      "address2": this.formSubmissionInfo.business.address2,
      "state": this.formSubmissionInfo.business.state,
      "city": this.formSubmissionInfo.business.city,
      "country": this.formSubmissionInfo.business.country,
      "pincode": this.formSubmissionInfo.business.zipCode,
      "personalInfo": {
        "authId": authId,
        "signInMethod": signInMethod,
        "firstName": this.formSubmissionInfo.personal.firstName,
        "lastName": this.formSubmissionInfo.personal.lastName,
        "email": this.formSubmissionInfo.email.emailCtrl,
        "images": "",
        "countryCode": isoCode,
        "stdCode": dialCode,
        "phoneNumber": phoneNo,
        "smsNumber": this.formSubmissionInfo.personal.mobNumber,
        "userRoleId": 0,
        "userTypeId": 2,
        "recordStatus": true,
        "registerStatus": true,
        "createdBy": 0
      }
    }
      this.clientFacade.onboardClient(data).subscribe({
        next: (response) => {
          if(response == "Studio number is already exists"){
            this.isProcessing = false;
            this.loadingUserDataByEmail = false;
            this.passwordMessage = "Suite number was already in use";
          }else if(response == "Already Exists"){
            this.isProcessing = false;
            this.loadingUserDataByEmail = false;
            this.passwordMessage = "This email was already registered";
          }else{
            this.clientId = response;
            this.cltLocationCreation();
           // window.location.href = 'https://serve.myvisitmaker.com/#/auth/login';
          }
        }, error: (error) => {
        }
      })
    } catch (error) {
      // handle error
    }
  }

  cltLocationCreation(){
    let data = {
      "id": 0,
      "clientId": this.clientId,
      "images": "",
      "locationName":this.formSubmissionInfo.business.cliLocName,
      "address1": this.formSubmissionInfo.business.address1,
      "address2": this.formSubmissionInfo.business.address2,
      "city": this.formSubmissionInfo.business.city,
      "state": this.formSubmissionInfo.business.state,
      "country": this.formSubmissionInfo.business.country,
      "pincode": this.formSubmissionInfo.business.zipCode,
      "timeZone": this.formSubmissionInfo.business.timezone,
      "recordStatus":true,
      "createdBy": 0
    }

    this.locationFacadeService.createLocation(data).subscribe((res: any) => {
      if (res == 'Invalid ZipCode') {
       
      } else if (res == 'Already Exists') {
       
      } else {
        this.isProcessing = false;
        this.loadingUserDataByEmail = false;
        this.locId = res;
      }
    }, (error) => {
      
    })
  }

  stylistCreation(){
    this.loadingUserDataByEmail = true;
    try {
      const authId = (this.onBoardingUserDetails.userTypeId == 1) ? (this.onBoardingUserDetails.authId) : (this.signupAuthInfo.authId);
      const signInMethod = (this.onBoardingUserDetails.userTypeId == 1) ? (this.onBoardingUserDetails.signInMethod) : (this.signupAuthInfo.signInMethod);
      const dialCode = '+' + this.phoneInputComponent.selectedCountry.dialCode;
      const isoCode = this.phoneInputComponent.selectedCountry.iso2.toString().toUpperCase();
      const phoneNo = this.phoneInputComponent.phoneNumber;
      let data = {
        "id": 0,
        "userId": 0,
        "locationId": this.locId,
        "about": "",
        "studioName": this.stylistFormGroup.value.studioName,
        "studioNumber": this.stylistFormGroup.value.studioNumber,
        "studioImage": "",
        "emailEnabled": true,
        "smsEnabled": true,
        "personalInfo": {
          "authId": authId,
          "signInMethod": signInMethod,
          "firstName": this.formSubmissionInfo.personal.firstName,
          "lastName": this.formSubmissionInfo.personal.lastName,
          "email": this.formSubmissionInfo.email.emailCtrl,
          "countryCode": isoCode,
          "stdCode": dialCode,
          "phoneNumber": phoneNo,
          "smsNumber": this.formSubmissionInfo.personal.mobNumber,
          "images": "",
          "userRoleId": 0,
          "userTypeId": 3,
          "recordStatus": true,
          "registerStatus": true,
          "createdBy": 0
        }
      }
      this.stylistFacadeService.onboardStylist(data).subscribe({
        next: (response) => {
          if(response == "Studio number is already exists"){
            this.isProcessing = false;
            this.loadingUserDataByEmail = false;
            this.passwordMessage = "Suite number was already in use";
          }else if(response == "Already Exists"){
            this.isProcessing = false;
            this.loadingUserDataByEmail = false;
            this.passwordMessage = "This email was already registered";
          }else{
            this.isProcessing = false;
            this.loadingUserDataByEmail = false;
           // window.location.href = 'https://serve.myvisitmaker.com/#/auth/login';
          }
        }, error: (error) => {
        }
      })
    } catch (error) {
      // handle error
    }
  }

  verifyEmail(authInfo: any) {
    this.loadingUserDataByEmail = true;
    try {
      this.userFacadeService.verifyEmailFirebase(authInfo.authId).subscribe({
        next: (response) => {
          this.submitOnboardingDetails();
        }, error: (error) => {
          // handle error here...
        }
      })
    } catch (error) {
      // handle error here
    }
  }

  errorSocialMessage(e: any) {
    let errorMsg: string = e;
    if (e == "email not match") {
      errorMsg = "Please use social media account having same email or create a new password.";
      this.passwordMessage = errorMsg;
    } else {
      if (e.code == 'auth/user-not-found') {
        errorMsg = 'Please enter the valid email address';
        this.passwordMessage = errorMsg;
      } else if (e.code == 'auth/wrong-password' || e.code == 'auth/invalid-password') {
        errorMsg = 'Password is incorrect';
        this.passwordMessage = errorMsg;
      }
      else if (e.code == 'auth/email-already-in-use' || e.code == "auth/email-already-exists") {
        errorMsg = 'This email is already in use';
        this.passwordMessage = errorMsg;
      } else {
        errorMsg = "Something went wrong, Please try again";
        this.passwordMessage = errorMsg;
      }
    }
  }

  setPasswordValidations() {
    this.password.setValidators([Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]);
    this.confirmPassword.setValidators([Validators.required]);
    this.personalFormGroup.setValidators([MustMatch('passwordCtrl', 'confirmPassCtrl')]);
  }

  removePasswordValidations() {
    this.password.setValidators(null);
    this.confirmPassword.setValidators(null);
    this.personalFormGroup.setValidators(null);
  }

  passwordClick() {
    this.showNewPassword = !this.showNewPassword;
    setTimeout(() => {
      this.showNewPassword = !this.showNewPassword;
    }, 3000);
  }

  confirmClick() {
    this.showConfirmPassword = !this.showConfirmPassword;
    setTimeout(() => {
      this.showConfirmPassword = !this.showConfirmPassword;
    }, 3000);
  }

  onCountrySelected(event: MatAutocompleteSelectedEvent){
    this.country = event.option.viewValue;
    this.fetchStateList();
  }

  fetchCountryList(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.locationFacadeService.getCountryList().subscribe({
        next: (response: any) => {
          this.countryList = response;
          this.isProcessing = false;
          this.registerCountryFilter();
          resolve();
        },
        error: (error) => {
          this.isProcessing = false;
          resolve();
        }
      })
    });
  }

  fetchStateList(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.locationFacadeService.getStateList(this.country).subscribe({
        next: (response: any) => {
          this.stateList = response;
          this.isProcessing = false;
          this.registerStateFilter();
          resolve();
        },
        error: (error) => {
          this.isProcessing = false;
          resolve();
        }
      })
    });
  }

  registerCountryFilter() {
    const country = this.businessFormGroup.get('country');
    this.filteredCountry = country.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterCountry(value))
    );
  }

  private _filterCountry(value: string) {
    const filterValue = value.toLowerCase();
    return this.countryList.filter(
      (country) => country.countryName?.toLowerCase().includes(filterValue)
    );
  }

  registerStateFilter() {
    const state = this.businessFormGroup.get('state');
    this.filteredState = state.valueChanges.pipe(
      startWith(''),
      map((val) => this._filterState(val))
    );
  }

  private _filterState(val: string) {
    const filterValue = val.toLowerCase();
    return this.stateList.filter(
      (st) => st.state?.toLowerCase().includes(filterValue)
    );
  }

  radioSelected(event){
    if(event.value == 1){
      this.styOptionVal = true;
    }else{
      this.styOptionVal = false;
    }
  }

  styEmailSend(){
    let data = {
      "email" : this.styEmailFormGroup.value.styEmail,
      "clientId" : Number(this.clientId),
    }
    this.stylistFacadeService.stylistEmail(data).subscribe({
      next: (response) => {
      }, error: (error) => {
      }
    })
  }

  onCountryChange(event) {

    if (event.iso2 !== 'us' && event.iso2 !== 'in') {
      this.selectedCountry = {
        "name": "United States",
        "iso2": "us",
        "dialCode": "1",
        "priority": 0,
        "flagClass": "US",
      }
      this.phoneInputComponent.selectedCountry = this.selectedCountry;
    } else {
      this.selectedCountry = event; // Otherwise, keep the selected country
    }

  }

}
